import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import { provisioningEnUS, provisioningZhCN } from './provisioning'
import { provisioningTerminologyZhCN } from './provisioning-terminology'
import { enCleanup, zhCleanup } from './zh-cleanup'
import { coverageEn } from './coverage-en'
import { watch } from 'vue'
import { displayLocale } from './localeState'

const preferenceMigrationKey = 'dcim.locale.system-default-v1'
if (!localStorage.getItem(preferenceMigrationKey)) {
  if (localStorage.getItem('dcim.locale') === 'en-US') localStorage.setItem('dcim.locale.preference', 'en-US')
  localStorage.setItem(preferenceMigrationKey, '1')
}

const stored = localStorage.getItem('dcim.locale.preference')
const locale = stored === 'en-US' ? 'en-US' : 'zh-CN'

function mergeMessages<T extends Record<string, unknown>>(base: T, extension: Record<string, unknown>): T {
  const result: Record<string, unknown> = { ...base }
  for (const [key, value] of Object.entries(extension)) {
    const existing = result[key]
    if (existing && typeof existing === 'object' && !Array.isArray(existing) && value && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = mergeMessages(existing as Record<string, unknown>, value as Record<string, unknown>)
    } else {
      result[key] = value
    }
  }
  return result as T
}

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': mergeMessages(mergeMessages(mergeMessages(zhCN, provisioningZhCN), zhCleanup), provisioningTerminologyZhCN),
    'en-US': mergeMessages(mergeMessages(mergeMessages(enUS, provisioningEnUS), enCleanup), coverageEn),
  },
})
watch(i18n.global.locale, value => {
  displayLocale.value = value
  document.documentElement.lang = value
}, { immediate: true, flush: 'sync' })
export default i18n
